"use strict";
/*
 * HSStepper
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSStepper = /** @class */ (function (_super) {
    __extends(HSStepper, _super);
    function HSStepper(el, options) {
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-stepper');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.currentIndex = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.currentIndex) || 1;
        _this.mode = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.mode) || 'linear';
        _this.isCompleted =
            typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isCompleted) !== 'undefined'
                ? concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isCompleted
                : false;
        _this.totalSteps = 1;
        _this.navItems = [];
        _this.contentItems = [];
        _this.init();
        return _this;
    }
    HSStepper.prototype.init = function () {
        this.createCollection(window.$hsStepperCollection, this);
        this.buildNav();
        this.buildContent();
        this.buildButtons();
        this.setTotalSteps();
    };
    HSStepper.prototype.getUncompletedSteps = function (inIncludedSkipped) {
        if (inIncludedSkipped === void 0) { inIncludedSkipped = false; }
        return this.navItems.filter(function (_a) {
            var isCompleted = _a.isCompleted, isSkip = _a.isSkip;
            return inIncludedSkipped ? !isCompleted || isSkip : !isCompleted && !isSkip;
        });
    };
    HSStepper.prototype.setTotalSteps = function () {
        var _this = this;
        this.navItems.forEach(function (item) {
            var index = item.index;
            if (index > _this.totalSteps)
                _this.totalSteps = index;
        });
    };
    // Nav
    HSStepper.prototype.buildNav = function () {
        var _this = this;
        this.el
            .querySelectorAll('[data-hs-stepper-nav-item]')
            .forEach(function (el) { return _this.addNavItem(el); });
        this.navItems.forEach(function (item) { return _this.buildNavItem(item); });
    };
    HSStepper.prototype.buildNavItem = function (item) {
        var _this = this;
        var index = item.index, isDisabled = item.isDisabled, el = item.el;
        if (index === this.currentIndex)
            this.setCurrentNavItem();
        if (this.mode !== 'linear' || isDisabled) {
            el.addEventListener('click', function () { return _this.handleNavItemClick(item); });
        }
    };
    HSStepper.prototype.addNavItem = function (el) {
        var _a = JSON.parse(el.getAttribute('data-hs-stepper-nav-item')), index = _a.index, _b = _a.isFinal, isFinal = _b === void 0 ? false : _b, _c = _a.isCompleted, isCompleted = _c === void 0 ? false : _c, _d = _a.isSkip, isSkip = _d === void 0 ? false : _d, _e = _a.isOptional, isOptional = _e === void 0 ? false : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.isProcessed, isProcessed = _g === void 0 ? false : _g, _h = _a.hasError, hasError = _h === void 0 ? false : _h;
        if (isCompleted)
            el.classList.add('success');
        if (isSkip)
            el.classList.add('skipped');
        if (isDisabled) {
            if (el.tagName === 'BUTTON' || el.tagName === 'INPUT')
                el.setAttribute('disabled', 'disabled');
            el.classList.add('disabled');
        }
        if (hasError)
            el.classList.add('error');
        this.navItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            isOptional: isOptional,
            isDisabled: isDisabled,
            isProcessed: isProcessed,
            hasError: hasError,
            el: el,
        });
    };
    HSStepper.prototype.setCurrentNavItem = function () {
        var _this = this;
        this.navItems.forEach(function (item) {
            var index = item.index, el = item.el;
            if (index === _this.currentIndex)
                _this.setCurrentNavItemActions(el);
            else
                _this.unsetCurrentNavItemActions(el);
        });
    };
    HSStepper.prototype.setCurrentNavItemActions = function (el) {
        el.classList.add('active');
        this.fireEvent('active', this.currentIndex);
        (0, utils_1.dispatch)('active.hs.stepper', this.el, this.currentIndex);
    };
    HSStepper.prototype.getNavItem = function (n) {
        if (n === void 0) { n = this.currentIndex; }
        return this.navItems.find(function (_a) {
            var index = _a.index;
            return index === n;
        });
    };
    HSStepper.prototype.setProcessedNavItemActions = function (item) {
        item.isProcessed = true;
        item.el.classList.add('processed');
    };
    HSStepper.prototype.setErrorNavItemActions = function (item) {
        item.hasError = true;
        item.el.classList.add('error');
    };
    HSStepper.prototype.unsetCurrentNavItemActions = function (el) {
        el.classList.remove('active');
    };
    HSStepper.prototype.handleNavItemClick = function (item) {
        var index = item.index;
        this.currentIndex = index;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
    };
    // Content
    HSStepper.prototype.buildContent = function () {
        var _this = this;
        this.el
            .querySelectorAll('[data-hs-stepper-content-item]')
            .forEach(function (el) { return _this.addContentItem(el); });
        this.navItems.forEach(function (item) { return _this.buildContentItem(item); });
    };
    HSStepper.prototype.buildContentItem = function (item) {
        var index = item.index;
        if (index === this.currentIndex)
            this.setCurrentContentItem();
    };
    HSStepper.prototype.addContentItem = function (el) {
        var _a = JSON.parse(el.getAttribute('data-hs-stepper-content-item')), index = _a.index, _b = _a.isFinal, isFinal = _b === void 0 ? false : _b, _c = _a.isCompleted, isCompleted = _c === void 0 ? false : _c, _d = _a.isSkip, isSkip = _d === void 0 ? false : _d;
        if (isCompleted)
            el.classList.add('success');
        if (isSkip)
            el.classList.add('skipped');
        this.contentItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            el: el,
        });
    };
    HSStepper.prototype.setCurrentContentItem = function () {
        var _this = this;
        if (this.isCompleted) {
            var finalContentItem = this.contentItems.find(function (_a) {
                var isFinal = _a.isFinal;
                return isFinal;
            });
            var otherContentItems = this.contentItems.filter(function (_a) {
                var isFinal = _a.isFinal;
                return !isFinal;
            });
            finalContentItem.el.style.display = '';
            otherContentItems.forEach(function (_a) {
                var el = _a.el;
                return (el.style.display = 'none');
            });
            return false;
        }
        this.contentItems.forEach(function (item) {
            var index = item.index, el = item.el;
            if (index === _this.currentIndex)
                _this.setCurrentContentItemActions(el);
            else
                _this.unsetCurrentContentItemActions(el);
        });
    };
    HSStepper.prototype.hideAllContentItems = function () {
        this.contentItems.forEach(function (_a) {
            var el = _a.el;
            return (el.style.display = 'none');
        });
    };
    HSStepper.prototype.setCurrentContentItemActions = function (el) {
        el.style.display = '';
    };
    HSStepper.prototype.unsetCurrentContentItemActions = function (el) {
        el.style.display = 'none';
    };
    HSStepper.prototype.disableAll = function () {
        var currentNavItem = this.getNavItem(this.currentIndex);
        currentNavItem.hasError = false;
        currentNavItem.isCompleted = false;
        currentNavItem.isDisabled = false;
        currentNavItem.el.classList.remove('error', 'success');
        this.disableButtons();
    };
    HSStepper.prototype.disableNavItemActions = function (item) {
        item.isDisabled = true;
        item.el.classList.add('disabled');
    };
    HSStepper.prototype.enableNavItemActions = function (item) {
        item.isDisabled = false;
        item.el.classList.remove('disabled');
    };
    // Buttons
    HSStepper.prototype.buildButtons = function () {
        this.backBtn = this.el.querySelector('[data-hs-stepper-back-btn]');
        this.nextBtn = this.el.querySelector('[data-hs-stepper-next-btn]');
        this.skipBtn = this.el.querySelector('[data-hs-stepper-skip-btn]');
        this.completeStepBtn = this.el.querySelector('[data-hs-stepper-complete-step-btn]');
        this.finishBtn = this.el.querySelector('[data-hs-stepper-finish-btn]');
        this.resetBtn = this.el.querySelector('[data-hs-stepper-reset-btn]');
        this.buildBackButton();
        this.buildNextButton();
        this.buildSkipButton();
        this.buildCompleteStepButton();
        this.buildFinishButton();
        this.buildResetButton();
    };
    // back
    HSStepper.prototype.buildBackButton = function () {
        var _this = this;
        if (!this.backBtn)
            return;
        this.checkForTheFirstStep();
        this.backBtn.addEventListener('click', function () {
            _this.handleBackButtonClick();
            if (_this.mode === 'linear') {
                var currentNavItem = _this.navItems.find(function (_a) {
                    var index = _a.index;
                    return index === _this.currentIndex;
                });
                var currentContentItem = _this.contentItems.find(function (_a) {
                    var index = _a.index;
                    return index === _this.currentIndex;
                });
                if (!currentNavItem || !currentContentItem)
                    return;
                if (currentNavItem.isCompleted) {
                    currentNavItem.isCompleted = false;
                    currentNavItem.isSkip = false;
                    currentNavItem.el.classList.remove('success', 'skipped');
                }
                if (currentContentItem.isCompleted) {
                    currentContentItem.isCompleted = false;
                    currentContentItem.isSkip = false;
                    currentContentItem.el.classList.remove('success', 'skipped');
                }
                if (_this.mode === 'linear' && _this.currentIndex !== _this.totalSteps) {
                    if (_this.nextBtn)
                        _this.nextBtn.style.display = '';
                    if (_this.completeStepBtn)
                        _this.completeStepBtn.style.display = '';
                }
                _this.showSkipButton();
                _this.showFinishButton();
                _this.showCompleteStepButton();
            }
        });
    };
    HSStepper.prototype.handleBackButtonClick = function () {
        if (this.currentIndex === 1)
            return;
        if (this.mode === 'linear') {
            this.removeOptionalClasses();
        }
        this.currentIndex--;
        if (this.mode === 'linear') {
            this.removeOptionalClasses();
        }
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn)
            this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.fireEvent('back', this.currentIndex);
        (0, utils_1.dispatch)('back.hs.stepper', this.el, this.currentIndex);
    };
    HSStepper.prototype.checkForTheFirstStep = function () {
        if (this.currentIndex === 1) {
            this.setToDisabled(this.backBtn);
        }
        else {
            this.setToNonDisabled(this.backBtn);
        }
    };
    HSStepper.prototype.setToDisabled = function (el) {
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT')
            el.setAttribute('disabled', 'disabled');
        el.classList.add('disabled');
    };
    HSStepper.prototype.setToNonDisabled = function (el) {
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT')
            el.removeAttribute('disabled');
        el.classList.remove('disabled');
    };
    // next
    HSStepper.prototype.buildNextButton = function () {
        var _this = this;
        if (!this.nextBtn)
            return;
        this.nextBtn.addEventListener('click', function () {
            var _a;
            _this.fireEvent('beforeNext', _this.currentIndex);
            (0, utils_1.dispatch)('beforeNext.hs.stepper', _this.el, _this.currentIndex);
            if ((_a = _this.getNavItem(_this.currentIndex)) === null || _a === void 0 ? void 0 : _a.isProcessed) {
                _this.disableAll();
                return false;
            }
            _this.goToNext();
        });
    };
    HSStepper.prototype.unsetProcessedNavItemActions = function (item) {
        item.isProcessed = false;
        item.el.classList.remove('processed');
    };
    HSStepper.prototype.handleNextButtonClick = function (infinite) {
        if (infinite === void 0) { infinite = true; }
        if (infinite) {
            if (this.currentIndex === this.totalSteps)
                this.currentIndex = 1;
            else
                this.currentIndex++;
        }
        else {
            var nonCompletedSteps = this.getUncompletedSteps();
            if (nonCompletedSteps.length === 1) {
                var index = nonCompletedSteps[0].index;
                this.currentIndex = index;
            }
            else {
                if (this.currentIndex === this.totalSteps)
                    return;
                this.currentIndex++;
            }
        }
        if (this.mode === 'linear') {
            this.removeOptionalClasses();
        }
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn)
            this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.fireEvent('next', this.currentIndex);
        (0, utils_1.dispatch)('next.hs.stepper', this.el, this.currentIndex);
    };
    HSStepper.prototype.removeOptionalClasses = function () {
        var _this = this;
        var currentNavItem = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === _this.currentIndex;
        });
        var currentContentItem = this.contentItems.find(function (_a) {
            var index = _a.index;
            return index === _this.currentIndex;
        });
        currentNavItem.isSkip = false;
        currentNavItem.hasError = false;
        currentNavItem.isDisabled = false;
        currentContentItem.isSkip = false;
        currentNavItem.el.classList.remove('skipped', 'success', 'error');
        currentContentItem.el.classList.remove('skipped', 'success', 'error');
    };
    // skip
    HSStepper.prototype.buildSkipButton = function () {
        var _this = this;
        if (!this.skipBtn)
            return;
        this.showSkipButton();
        this.skipBtn.addEventListener('click', function () {
            _this.handleSkipButtonClick();
            if (_this.mode === 'linear' && _this.currentIndex === _this.totalSteps) {
                if (_this.nextBtn)
                    _this.nextBtn.style.display = 'none';
                if (_this.completeStepBtn)
                    _this.completeStepBtn.style.display = 'none';
                if (_this.finishBtn)
                    _this.finishBtn.style.display = '';
            }
        });
    };
    HSStepper.prototype.setSkipItem = function (n) {
        var _this = this;
        var targetNavItem = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === (n || _this.currentIndex);
        });
        var targetContentItem = this.contentItems.find(function (_a) {
            var index = _a.index;
            return index === (n || _this.currentIndex);
        });
        if (!targetNavItem || !targetContentItem)
            return;
        this.setSkipItemActions(targetNavItem);
        this.setSkipItemActions(targetContentItem);
    };
    HSStepper.prototype.setSkipItemActions = function (item) {
        item.isSkip = true;
        item.el.classList.add('skipped');
    };
    HSStepper.prototype.showSkipButton = function () {
        var _this = this;
        if (!this.skipBtn)
            return;
        var isOptional = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === _this.currentIndex;
        }).isOptional;
        if (isOptional)
            this.skipBtn.style.display = '';
        else
            this.skipBtn.style.display = 'none';
    };
    HSStepper.prototype.handleSkipButtonClick = function () {
        this.setSkipItem();
        this.handleNextButtonClick();
        this.fireEvent('skip', this.currentIndex);
        (0, utils_1.dispatch)('skip.hs.stepper', this.el, this.currentIndex);
    };
    // complete
    HSStepper.prototype.buildCompleteStepButton = function () {
        var _this = this;
        if (!this.completeStepBtn)
            return;
        this.completeStepBtnDefaultText = this.completeStepBtn.innerText;
        this.completeStepBtn.addEventListener('click', function () {
            return _this.handleCompleteStepButtonClick();
        });
    };
    HSStepper.prototype.changeTextAndDisableCompleteButtonIfStepCompleted = function () {
        var _this = this;
        var currentNavItem = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === _this.currentIndex;
        });
        var completedText = JSON.parse(this.completeStepBtn.getAttribute('data-hs-stepper-complete-step-btn')).completedText;
        if (!currentNavItem)
            return;
        if (currentNavItem.isCompleted) {
            this.completeStepBtn.innerText =
                completedText || this.completeStepBtnDefaultText;
            this.completeStepBtn.setAttribute('disabled', 'disabled');
            this.completeStepBtn.classList.add('disabled');
        }
        else {
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute('disabled');
            this.completeStepBtn.classList.remove('disabled');
        }
    };
    HSStepper.prototype.setCompleteItem = function (n) {
        var _this = this;
        var targetNavItem = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === (n || _this.currentIndex);
        });
        var targetContentItem = this.contentItems.find(function (_a) {
            var index = _a.index;
            return index === (n || _this.currentIndex);
        });
        if (!targetNavItem || !targetContentItem)
            return;
        this.setCompleteItemActions(targetNavItem);
        this.setCompleteItemActions(targetContentItem);
    };
    HSStepper.prototype.setCompleteItemActions = function (item) {
        item.isCompleted = true;
        item.el.classList.add('success');
    };
    HSStepper.prototype.showCompleteStepButton = function () {
        if (!this.completeStepBtn)
            return;
        var nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1)
            this.completeStepBtn.style.display = 'none';
        else
            this.completeStepBtn.style.display = '';
    };
    HSStepper.prototype.handleCompleteStepButtonClick = function () {
        this.setCompleteItem();
        this.fireEvent('complete', this.currentIndex);
        (0, utils_1.dispatch)('complete.hs.stepper', this.el, this.currentIndex);
        this.handleNextButtonClick(false);
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        if (this.completeStepBtn)
            this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
    };
    // finish
    HSStepper.prototype.buildFinishButton = function () {
        var _this = this;
        if (!this.finishBtn)
            return;
        if (this.isCompleted) {
            this.setCompleted();
        }
        this.finishBtn.addEventListener('click', function () {
            return _this.handleFinishButtonClick();
        });
    };
    HSStepper.prototype.setCompleted = function () {
        this.el.classList.add('completed');
    };
    HSStepper.prototype.unsetCompleted = function () {
        this.el.classList.remove('completed');
    };
    HSStepper.prototype.showFinishButton = function () {
        if (!this.finishBtn)
            return;
        var nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1)
            this.finishBtn.style.display = '';
        else
            this.finishBtn.style.display = 'none';
    };
    HSStepper.prototype.handleFinishButtonClick = function () {
        var _this = this;
        var uncompletedSteps = this.getUncompletedSteps();
        var uncompletedOrSkipSteps = this.getUncompletedSteps(true);
        var el = this.contentItems.find(function (_a) {
            var isFinal = _a.isFinal;
            return isFinal;
        }).el;
        if (uncompletedSteps.length)
            uncompletedSteps.forEach(function (_a) {
                var index = _a.index;
                return _this.setCompleteItem(index);
            });
        this.currentIndex = this.totalSteps;
        this.setCurrentNavItem();
        this.hideAllContentItems();
        var currentNavItem = this.navItems.find(function (_a) {
            var index = _a.index;
            return index === _this.currentIndex;
        });
        var currentNavItemEl = currentNavItem ? currentNavItem.el : null;
        currentNavItemEl.classList.remove('active');
        el.style.display = 'block';
        if (this.backBtn)
            this.backBtn.style.display = 'none';
        if (this.nextBtn)
            this.nextBtn.style.display = 'none';
        if (this.skipBtn)
            this.skipBtn.style.display = 'none';
        if (this.completeStepBtn)
            this.completeStepBtn.style.display = 'none';
        if (this.finishBtn)
            this.finishBtn.style.display = 'none';
        if (this.resetBtn)
            this.resetBtn.style.display = '';
        if (uncompletedOrSkipSteps.length <= 1) {
            this.isCompleted = true;
            this.setCompleted();
        }
        this.fireEvent('finish', this.currentIndex);
        (0, utils_1.dispatch)('finish.hs.stepper', this.el, this.currentIndex);
    };
    // reset
    HSStepper.prototype.buildResetButton = function () {
        var _this = this;
        if (!this.resetBtn)
            return;
        this.resetBtn.addEventListener('click', function () {
            return _this.handleResetButtonClick();
        });
    };
    HSStepper.prototype.handleResetButtonClick = function () {
        var _this = this;
        if (this.backBtn)
            this.backBtn.style.display = '';
        if (this.nextBtn)
            this.nextBtn.style.display = '';
        if (this.completeStepBtn) {
            this.completeStepBtn.style.display = '';
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute('disabled');
            this.completeStepBtn.classList.remove('disabled');
        }
        if (this.resetBtn)
            this.resetBtn.style.display = 'none';
        this.navItems.forEach(function (item) {
            var el = item.el;
            item.isSkip = false;
            item.isCompleted = false;
            _this.unsetCurrentNavItemActions(el);
            el.classList.remove('success', 'skipped');
        });
        this.contentItems.forEach(function (item) {
            var el = item.el;
            item.isSkip = false;
            item.isCompleted = false;
            _this.unsetCurrentContentItemActions(el);
            el.classList.remove('success', 'skipped');
        });
        this.currentIndex = 1;
        this.unsetCompleted();
        this.isCompleted = false;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        this.fireEvent('reset', this.currentIndex);
        (0, utils_1.dispatch)('reset.hs.stepper', this.el, this.currentIndex);
    };
    // Public methods
    HSStepper.prototype.setProcessedNavItem = function (n) {
        var targetNavItem = this.getNavItem(n);
        if (!targetNavItem)
            return;
        this.setProcessedNavItemActions(targetNavItem);
    };
    HSStepper.prototype.unsetProcessedNavItem = function (n) {
        var targetNavItem = this.getNavItem(n);
        if (!targetNavItem)
            return;
        this.unsetProcessedNavItemActions(targetNavItem);
    };
    HSStepper.prototype.goToNext = function () {
        if (this.mode === 'linear')
            this.setCompleteItem();
        this.handleNextButtonClick(this.mode !== 'linear');
        if (this.mode === 'linear' && this.currentIndex === this.totalSteps) {
            if (this.nextBtn)
                this.nextBtn.style.display = 'none';
            if (this.completeStepBtn)
                this.completeStepBtn.style.display = 'none';
        }
    };
    HSStepper.prototype.disableButtons = function () {
        if (this.backBtn)
            this.setToDisabled(this.backBtn);
        if (this.nextBtn)
            this.setToDisabled(this.nextBtn);
    };
    HSStepper.prototype.enableButtons = function () {
        if (this.backBtn)
            this.setToNonDisabled(this.backBtn);
        if (this.nextBtn)
            this.setToNonDisabled(this.nextBtn);
    };
    HSStepper.prototype.setErrorNavItem = function (n) {
        var targetNavItem = this.getNavItem(n);
        if (!targetNavItem)
            return;
        this.setErrorNavItemActions(targetNavItem);
    };
    // Static methods
    HSStepper.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsStepperCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSStepper.autoInit = function () {
        if (!window.$hsStepperCollection)
            window.$hsStepperCollection = [];
        document
            .querySelectorAll('[data-hs-stepper]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsStepperCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSStepper(el);
        });
    };
    return HSStepper;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSStepper.autoInit();
    // Uncomment for debug
    // console.log('Stepper collection:', window.$hsStepperCollection);
});
if (typeof window !== 'undefined') {
    window.HSStepper = HSStepper;
}
exports.default = HSStepper;
